interface ListParams {
  status?: string;
  page?: number;
  pageSize?: number;
}

function buildList(base: string, params?: ListParams): string {
  const qs = new URLSearchParams();
  if (params?.status) qs.set('status', params.status);
  if (params?.page) qs.set('page', String(params.page));
  if (params?.pageSize) qs.set('pageSize', String(params.pageSize));
  const q = qs.toString();
  return q ? `${base}?${q}` : base;
}

export const approvalEndpoints = {
  count: () => '/mobile/approvals/count',
  list: (params?: ListParams) => buildList('/mobile/approvals', params),
  detail: (id: string) => `/mobile/approvals/${id}`,
  approve: (id: string) => `/mobile/approvals/${id}/approve`,
  reject: (id: string) => `/mobile/approvals/${id}/reject`,
  // Other modules' items (the restaurant's requisitions, S3b).
  contributed: () => '/mobile/approvals/contributed',
  decideContributed: (source: string, itemId: string, decision: 'approve' | 'reject') =>
    `/mobile/approvals/contributed/${encodeURIComponent(source)}/${itemId}/${decision}`,
};
